import RestApiModel from "@/api/Model/RestApiModel";

class CompanyGroup extends RestApiModel {
  static getResourceEndpoint() {
    return '/company-groups';
  }
}

export default CompanyGroup;
